module.exports = "<a href=# class=edit-webhook-btn id=\"{%- index %}\">{%- webHookClassName %} </a>";


//////////////////
// WEBPACK FOOTER
// ./src/pages/webhooks/html/editWebhookLink.html
// module id = 1445
// module chunks = 1